<template>
  <div :style="{direction:$t('direction')}">
    <div class="dashboard">
      <Sidebar />
      <div class="content">
        <Header />
        <div class="dashboard-content" ref="container">
        <HelperNav />
          <div class="dashboard-wrapper">

            <div class="ar-card">
              <div class="ar-card-header">
                <div class="ar-card-title">
                  خرید و فروش فوری 
                  <i class="mdi mdi-information-outline popover-activator" tabindex="1">
                    <div class="ar-popover">
                       کاربر گرامی, فقط برای خرید یا فروش تتر از این بخش استفاده نمایید.
                    </div>
                  </i>
                  
                </div>
                <span></span>
              </div>
              <div class="ar-card-body">

            
                <div class="ar-tabs mt-3 px-2">
                  <div class="ar-tab-item success" :class="[active_tab == 'buy' ? 'active' : '']" @click="active_tab = 'buy'">
                    خرید
                  </div>
                  <div class="ar-tab-item danger" :class="[active_tab == 'sell' ? 'active' : '']" @click="active_tab = 'sell'">
                    فروش
                  </div>
                </div>

                <template v-if="active_tab === 'buy' && state_setting.id != undefined">

                  <template v-if="!parseFloat(state_setting.fast_buy)">
                    <div class="px-2 py-5 text-center text-primary-dark">
                      با توجه به بروزرسانی سیستم لطفا بعدا تلاش نمایید.
                    </div>
                  </template>

                  <template v-else>
                    <template v-if="buy_step === 1">
  
                      <div class="m-auto" style="max-width:400px;">
                        <div class="magic-input-box">
                          <div class="magic-input">
                            <input class="latin-input-3" onclick="this.select()" @keypress="just_float($event)" @input="buy_feild_changed(true)" v-model="buy.amount" placeholder="مقدار پرداختی">
                          </div>
                          <div class="magic-titr">تومان</div>
                        </div>
  
                        <div class="magic-input-box">
                          <div class="magic-input">
                            <input class="latin-input-3" onclick="this.select()" @keypress="just_float($event)" @input="buy_feild_changed(false)" v-model="buy.receive" placeholder="مقدار دریافتی">
                          </div>
                          <div class="magic-titr">تتر</div>
                        </div>
  
                        <div class="text-center">
                          <button v-if="!buy.amount" class="ar-btn size-xl round primary disabled">ادامه</button>
                          <button v-else class="ar-btn size-xl round primary" @click="getAdminAccount()">ادامه</button>
                        </div>
                      </div>
  
                    </template>
                    <template v-if="buy_step === 2">
  
                      <div class="row p-3">
                        <div class="col-lg-5 col-sm-12">
                          <div class="ar-card size-sm text-primary-dark">
                            <div class="ar-card-header justify-content-center">
                              <div class="ar-card-title">فاکتور</div>
                            </div>
                            <div class="ar-card-body">
                              
                              <div class="text-center mb-2">
                                <router-link :to="{name:'PaymentAdvanceInvoice'}" class="ar-btn size-sm success round">فاکتور پیش پرداخت</router-link>
                              </div>
  
                              <div class="text-center mb-2">
                                <button class="ar-btn size-sm primary round">خرید تتر</button>
                              </div>
                              
                              <div class="d-flex justify-content-between mb-3">
                                <div>نام خریدار</div>
                                <div>{{ userData.fullname }}</div>
                              </div>
                              <div class="d-flex justify-content-between mb-3">
                                <div>میزان خرید</div>
                                <div>{{buy.amount}} تومان </div>
                              </div>
                              <div class="d-flex justify-content-between mb-3">
                                <div>قیمت هر واحد</div>
                                <div>{{ formatPrice(state_prices.sale_price) }} تومان</div>
                              </div>
                              <div class="d-flex justify-content-between mb-3">
                                <div>کارمزد مبادله</div>
                                <div>0</div>
                              </div>
  
                              <div style="background:#E2DEDE;padding:.5rem;border-radius:.5rem">
  
                                <div class="d-flex justify-content-between mb-3">
                                  <div>مقدار واریزی</div>
                                  <div>{{buy.amount}} تومان</div>
                                </div>
                                <div class="d-flex justify-content-between">
                                  <div>میزان دریافتی</div>
                                  <div>{{buy.receive}} تتر</div>
                                </div>
  
                              </div>
  
                              <small class="mt-3">کارمزد شما در این تبادل صفر می باشد.</small>
                            </div>
                            <div class="ar-card-footer py-2">
                              <div><small class="font-07">تسویه تتر بعد از تایید تراکنش بانکی صورت می گیرد. میزان دقیق بعد از تایید تراکنش بانکی اعمال میگردد.</small></div>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-7 col-sm-12 pt-3 text-primary-dark">
                          
                          <div class="ar-form-group">
                            <div class="text-center py-1">
                              <add-wallet>
                                <button class="ar-btn size-xs primary round">افزودن ولت <i class="mdi mdi-plus"></i></button>
                              </add-wallet>
                            </div>
                            <select class="ar-form-control text-center" v-model="buy.wallet_id">
                              <option :value="null" disabled hidden>لطفا ولت خود را انتخاب نمایید</option>
                              <option v-for="(item , key) in state_wallets" :key="key" :value="item.id" class=" font-en">{{ item.address }}</option>
                            </select>
                            <div v-if="errors.wallet_id" class="ar-form-text text-danger">
                              <small>انتخاب ولت الزامی است</small>
                            </div>
                          </div>
  
                          <small> مسئولیت صحت کیف پول به عهده کاربر می باشد. لطفا در وارد کردن کیف پول دقت کنید.</small>
                          <small>کارمزد تتر بنابر شبکه انتقال متغییر می باشد و ارزینه در آن هیچ دخالتی ندارد.</small>
                          
                          <h3 class="mt-3"> <i style="position:relative;top:6px" class="mdi mdi-circle"></i> روش های پرداخت</h3>
                          <div class="buy-sell-payment-method">
  
                            <div class="payment-method-item disabled" :class="[buy.payment_method == 'gateway' ? 'active' : '']" >
                              <div class="payment-method-bullet"></div>
                              <div class="payment-method-title">پرداخت اینترنتی</div>
                            </div>
  
                            <div class="payment-method-item" :class="[buy.payment_method == 'card' ? 'active' : '']" @click="buy.payment_method = 'card'">
                              <div class="payment-method-bullet"></div>
                              <div class="payment-method-title">پرداخت از طریق بانک, همراه بانک و کارت به کارت</div>
                            </div>
  
                            <div class="payment-method-item disabled" :class="[buy.payment_method == 'credit' ? 'active' : '']" >
                              <div class="payment-method-bullet"></div>
                              <div class="payment-method-title"> پرداخت اعتباری (از سبد دارایی)</div>
                            </div>
  
                            <div class="payment-method-item" :class="[buy.payment_method == 'vandar' ? 'active' : '']" @click="buy.payment_method = 'vandar'">
                              <div class="payment-method-bullet"></div>
                              <div class="payment-method-title">پرداخت از طریق سرویس وندار</div>
                            </div>
  
                          </div>
  
  
                        </div>
                      </div>
                      
                      <div class="text-center">
                        <button class="ar-btn size-md round info mx-3" @click="buy_step = 1">گام قبلی</button>
                        <button v-if="!buy.payment_method || !buy.wallet_id" class="ar-btn size-md round primary disabled">تایید و ادامه</button>
                        <template v-else>
                          <button v-if="buy.payment_method == 'vandar'" class="ar-btn size-md round primary" @click="submitVandarBuyReq()">تایید و ادامه</button>
                          <button v-if="buy.payment_method == 'card'" class="ar-btn size-md round primary" @click="$refs.container.scrollTop = 100 , buy_step = 3">تایید و ادامه</button>
                        </template>
                      </div>
                      
                    </template>
                    <template v-if="buy_step === 3">
                      
                      <div class="text-primary-dark m-auto" style="max-width:400px;">
                        
                        <div class="ar-form-group">
                          <div class="text-center py-1">
                            <add-bank-account>
                              <button class="ar-btn size-xs primary round">افزودن کارت بانکی <i class="mdi mdi-plus"></i></button>
                            </add-bank-account>
                          </div>
                          <select class="ar-form-control text-center" v-model="buy.bank_account_id">
                            <option :value="null" disabled hidden>انتخاب کارت بانکی</option>
                            <option v-for="(item , key) in state_bank_accounts" :key="key" :value="item.id">{{ item.card_number }}</option>
                          </select>
                          <div v-if="errors.bank_account_id" class="ar-form-text text-danger">
                            <small>انتخاب کارت بانکی الزامی است.</small>
                          </div>
                        </div>
  
                        <small>کاربر گرامی , لطفا فقط از حساب های بانکی خودتان استفاده کنید.</small>
                        <small>درصورت مغایرت در نام خریدار و نام صاحب حساب , فاکتور خرید باطل و مبلغ بعد از 
                          72 ساعت به مبدا بازگشت داده می شود.</small>
  
                        <div class="my-4">
                          <h4 class="text-center">
                            حساب های مورد تایید صرافی ارزینه, افتخار پارسیان
                          </h4>
                        </div>
  
                        <div class="ar-form-group">
                          <label>
                            کاربر گرامی برای واریز وجه خود لطفا یکی از حساب های زیر را انتخاب نمایید.
                          </label>
                          <select @change="selectAdminBankAccount()" class="ar-form-control text-center" v-model="buy.admin_bank_account_id">
                            <option :value="null" disabled hidden>انتخاب حساب بانکی ارزینه</option>
                            <option v-for="(item , key) in admin_bank_accounts" :key="key" :value="item.id">{{ item.card_name }}</option>
                          </select>
                          <div v-if="errors.admin_bank_account_id" class="ar-form-text text-danger">
                            <small>انتخاب حساب بانکی ارزینه الزامی است.</small>
                          </div>
                        </div>
                        
                        <template v-if="admin_bank_account.id">
                          <!-- <div class="ar-form-group">
                            <label>نام صاحب حساب</label>
                            <input class="ar-form-control text-center" disabled v-model="admin_bank_account.card_name">
                          </div> -->
                          
                          <div v-if="admin_bank_account.bank_name" class="text-center py-3">
                            <img :src="StaticImageUrl+'assets/images/banks/'+ admin_bank_account.bank_name +'.svg'" width="60px" class="m-auto">
                          </div>
  
                          <div class="ar-form-group">
                            <label>شماره کارت</label>
                            <input class="ar-form-control text-center" disabled v-model="admin_bank_account.card_number">
                          </div>
                          
                          <div class="ar-form-group">
                            <label>شماره حساب</label>
                            <input class="ar-form-control text-center" disabled v-model="admin_bank_account.account_number">
                          </div>
                          
                          <div class="ar-form-group">
                            <label>شماره شبا</label>
                            <input class="ar-form-control text-center" disabled v-model="admin_bank_account.shaba_number">
                          </div>
                        </template>
  
                        <h4 class="text-center mt-5">ارسال فیش واریزی</h4>
                        <label v-if="buy_receipt.length < 3" for="buy_receipt" class="buy-sell-upload">
                          <input type="file" id="buy_receipt" @change="buy_receipt_changed($event)" accept="image/*">
                          <span>+افزودن فایل</span>
                          <i style="font-size : 24px" class="mdi mdi-cloud-upload-outline"></i>
                        </label>

                        <div class="text-center">
                          <small>می توانید 3 تصویر انتخاب نمایید.</small>
                        </div>
  
                        <div v-for="(item , key) in buy_receipt" :key="key" class="text-center mt-2">
                          {{ item.name }}
                        </div>
                        
                        <div class="row my-4">
                          <div class="col-6">
                            <button class="ar-btn size-md round info block" @click="buy_step = 2">گام قبلی</button>
                          </div>
                          <div class="col-6">
                            <button class="ar-btn size-md round primary block" @click="submitBuyReq()">ثبت مبادله</button>
                          </div>
                        </div>
  
                      </div>
  
                    </template>
                    <template v-if="buy_step === 4">
                      
                      <div class="mdi mdi-close font-3" @click="buy_step = 1"></div>
                      <div class="text-primary-dark py-5 text-center">
                        <div>ثبت درخواست خرید با موفقیت انجام شد.</div>
  
                        <div>تتر شما بعد از تایید تراکنش بانکی به ولت یا سبد دارایی شما اضافه می گردد.</div>
                      </div>
  
                    </template>
                  </template>


                </template>

                <template v-if="active_tab === 'sell' && state_setting.id != undefined" class="m-auto" style="max-width:400px;">

                  <template v-if="!parseFloat(state_setting.fast_sale)">
                    <div class="px-2 py-5 text-center text-primary-dark">
                      با توجه به بروزرسانی سیستم لطفا بعدا تلاش نمایید.
                    </div>
                  </template>

                  <template v-else>
                    <template v-if="sell_step === 1">
                      <div class="m-auto" style="max-width:400px;">
                        <div class="magic-input-box">
                          <div class="magic-input">
                            <input class="latin-input-3" onclick="this.select()" @keypress="just_float($event)" @input="sell_feild_changed(true)" v-model="sell.amount" placeholder="مقدار پرداختی">
                          </div>
                          <div class="magic-titr">تتر</div>
                        </div>

                        <div class="magic-input-box">
                          <div class="magic-input">
                            <input class="latin-input-3" onclick="this.select()" @keypress="just_float($event)" @input="sell_feild_changed(false)" v-model="sell.receive" placeholder="مقدار دریافتی">
                          </div>
                          <div class="magic-titr">تومان</div>
                        </div>

                        <div class="text-center">
                          <button v-if="!sell.amount" class="ar-btn size-xl round primary disabled">ادامه</button>
                          <button v-else class="ar-btn size-xl round primary" @click="checkSellAmount()">ادامه</button>
                        </div>
                      </div>
                    </template>

                    <template v-if="sell_step === 2">

                      <div class="row p-3">
                        <div class="col-lg-12 col-sm-12 pt-3 text-primary-dark">
                          
                          <div>شبکه انتقال را انتخاب کنید.</div>
                          
                          <div class="buy-sell-select-networks">
                            <div v-for="(item , key) in networks" :key="key" class="select-networks-item font-en">
                              <button class="ar-btn size-lg round" :class="[admin_wallet.network === item.network ? 'primary' : 'disabled']" @click="admin_wallet = item , confirm_modal = true">{{ item.network }}</button>
                            </div>
                          </div>

                          <div class="ar-form-group">
                            <label>تتر واریزی خود را بر اساس شبکه انتخاب شده به آدرس ولت زیر ارسال نمایید.</label>
                            <div class="ar-form-append">
                              <input disabled class="ar-form-control text-center font-en" v-model="admin_wallet.address">
                              <span class="ar-form-icon popover-activator" tabindex="1" @click="CopyText(admin_wallet.address)">
                                <i class="mdi mdi-content-copy"></i>
                                <span class="ar-popover">
                                  کپی شد
                                </span>
                              </span>
                            </div>
                            <div v-if="admin_wallet.qr_code_file" class="text-left">
                              <small class="cp" @click="qr_code_modal = true">نمایش کد QR<i class="mdi mdi-qrcode"></i></small>
                            </div>
                          </div>
                          <div class="ar-form-group">
                            <label>
                              لطفا هش تراکنش را وارد کنید.
                              <i class="mdi mdi-information-outline"></i>
                            </label>
                            <input class="ar-form-control text-center font-en" placeholder="TXID" v-model="sell.txid">
                            <div v-if="errors.txid" class="ar-form-text text-danger">
                              <small>وارد کردن txid الزامی بوده و نباید تکراری باشد.</small>
                            </div>
                          </div>

                          <div class="ar-form-group">
                            <div class="text-center py-1">
                              <add-bank-account>
                                <button class="ar-btn size-xs primary round">افزودن کارت بانکی <i class="mdi mdi-plus"></i></button>
                              </add-bank-account>
                            </div>
                            <select class="ar-form-control text-center" v-model="sell.bank_account_id" style="direction:ltr;">
                              <option :value="null" disabled hidden>انتخاب کارت بانکی</option>
                              <option v-for="(item , key) in state_bank_accounts" :key="key" :value="item.id">{{ item.card_number }}</option>
                            </select>
                          </div>

                          <!-- <div class="mb-4">
                          <small>درصورت انتخاب نکردن حساب بانکی , مبلغ دریافتی به سبد دارایی شما اضافه می گردد.</small>
                          </div> -->

                        </div>
                      </div>
                      
                      <div class="text-center">
                        <button class="ar-btn size-md round info mx-3" @click="sell_step = 1">گام قبلی</button>
                        <button v-if="!sell.txid || !sell.bank_account_id" class="ar-btn size-md round primary disabled">تایید و ادامه</button>
                        <button v-else class="ar-btn size-md round primary" @click="submitSellReq()">تایید و ادامه</button>
                      </div>

                    </template>

                    <template v-if="sell_step === 3">

                      <div class="row">
                        
                        <div class="col-lg-12 col-sm-12">
                          <div class="ar-card size-sm text-primary-dark">
                            <div class="ar-card-header justify-content-center">
                              <div class="ar-card-title text-danger">فاکتور تایید نشده</div>
                            </div>
                            <div class="ar-card-body">

                              <div class="text-center mb-2">
                                <button class="ar-btn size-sm primary round">فروش تتر</button>
                              </div>
                              
                              <div class="d-flex justify-content-between mb-3">
                                <div>نام فروشنده</div>
                                <div>{{ userData.fullname }}</div>
                              </div>
                              <div class="d-flex justify-content-between mb-3">
                                <div>میزان فروش</div>
                                <div>{{sell.amount}} تتر </div>
                              </div>
                              <div class="d-flex justify-content-between mb-3">
                                <div>قیمت هر واحد</div>
                                <div>{{ formatPrice(state_prices.buy_price) }} تومان</div>
                              </div>
                              <div class="d-flex justify-content-between mb-3">
                                <div>کارمزد مبادله</div>
                                <div>0</div>
                              </div>

                              <div style="background:#E2DEDE;padding:.5rem;border-radius:.5rem">

                                <div class="d-flex justify-content-between mb-3">
                                  <div>مقدار واریزی</div>
                                  <div>{{sell.amount}} تتر</div>
                                </div>
                                <div class="d-flex justify-content-between">
                                  <div>میزان دریافتی</div>
                                  <div>{{sell.receive}} تومان</div>
                                </div>

                              </div>

                              <div>
                                <small class="mt-3">کارمزد شما در این تبادل صفر می باشد.</small>
                              </div>
                              <div><small class="mt-3">این فاکتور صرفا جهت اطلاع شما از جزئیات مبادله نمایش داده می شود و به معنی نهایی بودن مبالغ ثبت شده در این فاکتور نیست.</small></div>
                              <div><small class="mt-3">مبلغ و تایید فاکتور بعد از دریافت تتر و تایید ارزینه نهایی می گردد و در قسمت تاریخچه مبادلات در دسترس است .</small></div>
                              <div><small class="mt-3">بدیهی است مبلغ واریزی به حساب کاربران مبلغ تایید نهایی شده از سمت ارزینه می باشد.</small></div>
                            </div>
                            <div class="ar-card-footer py-2">
                              <div><small class="font-07">تسویه مبلغ بعد از تایید تراکنش صورت می گیرد. میزان دقیق بعد از تایید تراکنش اعمال میگردد.</small></div>
                              <div class="text-center">
                                <button class="ar-btn size-md round primary" @click="reset()">متوجه شدم</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                    </template>

                  </template>
                </template>

              </div>
            </div>

            <div class="p-4 text-center my-2">
              <button class="ar-btn size-xl primary round" style="padding:2rem 3rem">
                <router-link :to="{name:'ConvertCrypto'}" class="ml-2">فروش کریپتو</router-link>
                <i class="mdi mdi-information-outline popover-activator hover" tabindex="1">
                  <div class="ar-popover">
                    کاربر گرامی, برای فروش دارایی دیجیتال خود (لیست شده در صرافی بایننس) به جز تتر از این بخش استفاده نمایید.
                  </div>
                </i>
              </button>
            </div>

            <div class="ar-card mt-3 mb-5">
              <div class="ar-card-header">
                <div class="ar-card-title">
                  تاریخچه
                </div>
                <span></span>
              </div>
              <div class="ar-card-body">

                <div v-if="!Object.keys(histories).length" class="p-4 text-center">هنوز درخواستی ایجاد نشده است.</div>

                <div v-if="active_tab === 'buy'" class="table-responsive">
                  <table class="table ar-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>مقدار واریزی</th>
                        <th>میزان دریافتی</th>
                        <th>وضعیت درخواست</th>
                        <th>زمان</th>
                        <th>جزئیات</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item , key) in histories" :key="key">
                        <td>{{ key+1 }}</td>
                        <td>
                          <template v-if="item.paid_currency == 'IRR'">
                            {{formatPrice(item.paid_amount)}} تومان 
                          </template>
                          <template v-else>
                            {{item.paid_amount}} {{item.paid_currency}} 
                          </template>
                        </td>

                        <td>
                          <template v-if="item.received_currency == 'USDT'">
                            {{ item.received_amount }} تتر 
                          </template>
                          <template v-else>
                            {{item.received_amount}} {{item.received_currency}} 
                          </template>
                        </td>
                        <td>
                          <span class="text-warning" v-if="item.status == 0">در حال بررسی</span>
                          <span class="text-success" v-if="item.status == 1">انجام شده</span>
                          <span class="text-danger" v-if="item.status == 2">رد شده</span>
                          <span class="text-primary" v-if="item.status == 3">در حال ارسال</span>
                        </td>
                        <td>
                          {{item.registered_at}}
                        </td>
                        <td>
                          <span :class="[
                              (item.status == 0 ? 'text-warning' : ''),
                              (item.status == 1 ? 'text-success' : ''),
                              (item.status == 2 ? 'text-danger' : ''),
                              (item.status == 3 ? 'text-primary' : '')
                            ]"
                          >
                            <router-link :to="{name:'ExchangeDetails' , params:{id:item.uuid}}">
                              <i class="mdi mdi-information-outline"></i>
                            </router-link>
                          </span>

                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-if="active_tab === 'sell'" class="table-responsive">
                  <table class="table ar-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>میزان واریزی</th>
                        <th>مقدار دریافتی</th>
                        <th>وضعیت درخواست</th>
                        <th>زمان</th>
                        <th>جزئیات</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item , key) in histories" :key="key">
                        <template v-if="item.paid_currency == 'USDT'">
                        <td>{{ key+1 }}</td>
                        <td>
                          <template v-if="item.paid_currency == 'USDT'">
                            {{ item.paid_amount }} تتر 
                          </template>
                          <template v-else>
                            {{item.paid_amount}} {{item.paid_currency}} 
                          </template>
                        </td>
                        <td>
                          <template v-if="item.received_currency == 'USDT'">
                            {{ item.received_amount }} تتر 
                          </template>
                          <template v-if="item.received_currency == 'IRR'">
                            {{formatPrice(item.received_amount)}} تومان
                          </template>
                        </td>
                        <td>
                          <span class="text-warning" v-if="item.status == 0">در حال بررسی</span>
                          <span class="text-success" v-if="item.status == 1">انجام شده</span>
                          <span class="text-danger" v-if="item.status == 2">رد شده</span>
                          <span class="text-primary" v-if="item.status == 3">در حال واریز</span>
                          <span class="text-primary" v-if="item.status == 4">در حال واریز</span>
                        </td>
                        <td>
                          {{item.registered_at}}
                        </td>
                        <td>
                          <span :class="[
                              (item.status == 0 ? 'text-warning' : ''),
                              (item.status == 1 ? 'text-success' : ''),
                              (item.status == 2 ? 'text-danger' : ''),
                              (item.status == 3 ? 'text-primary' : '')
                            ]"
                          >
                            <router-link :to="{name:'ExchangeDetails' , params:{id:item.uuid}}">
                              <i class="mdi mdi-information-outline"></i>
                            </router-link>
                          </span>

                        </td>
                        </template>
                      </tr>
                    </tbody>
                  </table>
                </div>

              </div>
            </div>

            <div class="py-5"></div>

          </div>
        </div>
      </div>
    </div>

    
    <modal @close="confirm_modal = false" :open="confirm_modal" :maxWitdh="'600px'">
      
      <div class="ar-card">
        <div class="ar-card-header">
          <span></span>
          <div class="ar-card-title">
            توجه 
          </div>
          <span>
            <i @click="confirm_modal = false" class="mdi mdi-close"></i>
          </span>
        </div>
        <div class="ar-card-body text-right">
          
          شما شبکه <span class="font-en">{{ admin_wallet.network }}</span> را برای انتقال انتخاب کرده اید. در صورت اطمینان از شبکه انتخاب شده عملیات خود را ادامه دهید.
          
        </div>
        <div class="ar-card-footer text-center">
          <button @click="confirm_modal = false" class="ar-btn size-sm primary mx-3">تایید</button>
        </div>
      </div>

    </modal>
    
    <modal @close="qr_code_modal = false" :open="qr_code_modal" :maxWitdh="'400px'">
      
      <div class="ar-card">
        <div class="ar-card-header">
          <span></span>
          <div class="ar-card-title">
            اسکن کد QR 
          </div>
          <span>
            <i @click="qr_code_modal = false" class="mdi mdi-close"></i>
          </span>
        </div>
        <div class="ar-card-body text-right">
          <img :src="ImageUrl + admin_wallet.qr_code_file" style="width:100%;height:auto;">
        </div>
        <div class="ar-card-footer text-center">
          <button @click="qr_code_modal = false" class="ar-btn size-sm primary mx-3">تایید</button>
        </div>
      </div>

    </modal>

  </div>
</template>
<script>
import Sidebar from './partials/Sidebar'
import Header from './partials/Header'
import Modal from '../../components/Modal.vue'
import {TheMask} from 'vue-the-mask'
import AddWallet from '../../components/AddWallet.vue'
import HelperNav from './partials/HelperNav'
import AddBankAccount from '../../components/AddBankAccount.vue'
import {io} from 'socket.io-client';
export default {
  name: 'Transaction',
  components:{
    Sidebar, Header, Modal, 
    TheMask,
    HelperNav,
    AddWallet,
    AddBankAccount,
  },
  data : () => ({
    buy:{
      wallet_id:null,
      admin_bank_account_id:null,
      bank_account_id:null,
      payment_method:null
    },
    buy_step : 1,
    admin_bank_account:{},
    admin_bank_accounts:[],
    buy_receipt:[],

    sell:{
      bank_account_id:null,
      network:null,
    },
    sell_step : 1,
    networks:[],
    admin_wallet:{},
    confirm_modal : false,
    qr_code_modal : false,

    errors:{},
    error_text:null,
    active_tab:'buy',
    socket:null,

    histories:[],
  }),
  computed:{
    confirmed_bank_accounts()
    {
      const confirmed = this.state_bank_accounts.filter(bank_account => {
        return bank_account.status == 1;
      });

      return confirmed;
    }
  },
  watch:{
    active_tab(){
      this.getHistories()
    },
    state_bank_accounts(){
      if(this.state_bank_accounts.length){
        if(this.active_tab == 'buy'){
          this.buy.bank_account_id = this.state_bank_accounts[0].id
        }else{
          this.sell.bank_account_id = this.state_bank_accounts[0].id
        }
      }
    },
    state_wallets(){
      this.buy.wallet_id = this.state_wallets[0].id
    }
  },
  methods:{
    buy_receipt_changed(event){
      this.buy_receipt.push(event.target.files[0]);
    },

    buy_feild_changed(type)
    {
      const isNumeric = /^[-+]?(\d+|\d+\.\d*|\d*\.\d+)$/;
      if(type){

        if(this.buy.amount){
          this.buy.amount =  this.buy.amount.replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d))
          const amount = this.buy.amount.replace(/,/g, "");
          if(isNumeric.test(amount)) {
            const number = parseFloat(amount / this.state_prices.sale_price)
            this.buy.receive = parseFloat(number.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0])
            this.buy.amount = this.formatPrice(amount)
          }else{
            this.buy.receive = null
            this.buy.amount = null
          }
        }else{
          this.buy.receive = null
        }

      }else{
        if(this.buy.receive){
          this.buy.receive = this.buy.receive.replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d))
          if (isNumeric.test(this.buy.receive)) {
            const number = parseInt(this.buy.receive * this.state_prices.sale_price)
            this.buy.amount = this.formatPrice(number)
          }else{
            this.buy.amount = null
            this.buy.receive = null
          }
        }else{
          this.buy.amount = null
        }
      }

    },
    sell_feild_changed(type)
    {
      const isNumeric = /^[-+]?(\d+|\d+\.\d*|\d*\.\d+)$/;
      if(type){
        
        if(this.sell.amount){
          this.sell.amount = this.sell.amount.replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d))
          if (isNumeric.test(this.sell.amount)) {
            const number = parseInt(this.sell.amount * this.state_prices.buy_price)
            this.sell.receive = this.formatPrice(number)
          }else{
            this.sell.amount = null
            this.sell.receive = null
          }
        }else{
          this.sell.receive = null
        }

      }else{

        if(this.sell.receive){
          this.sell.receive = this.sell.receive.replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d))
          const receive = this.sell.receive.replace(/,/g, "");
          if (isNumeric.test(receive)) {
            const number = parseFloat(receive / this.state_prices.buy_price).toFixed(2)
            this.sell.amount = parseFloat(number)
            this.sell.receive = this.formatPrice(receive)
          }else{
            this.sell.amount = null
            this.sell.receive = null
          }

        }else{
          this.sell.amount = null
        }

      }
    },

    getAdminAccount(){
      this.errors = {}
      let paid_amount = this.buy.amount.replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d))
      paid_amount = paid_amount.replace(/,/g, "")
      if(!paid_amount){
        this.$notify({ group: 'foo', type: 'error', duration: 5000, text: 'لطفا مقدار پرداختی را وارد نمایید'});
        return
      }
      if(paid_amount < 500000){
        this.$notify({ group: 'foo', type: 'error', duration: 5000, text: 'میزان پرداختی شما باید بیشتر از 500,000 تومان باشد.'});
        return
      }
      
      this.activeLoading(true)
      const api_token = this.getToken()
      this.$axios.post(`getAdminAccount` , {},
      {
        headers: {
          'api_token':api_token
        }
      })
      .then(res => {
        this.admin_bank_accounts = res.data.data
        this.admin_bank_account = {}
        this.buy.admin_bank_account_id = null

        this.buy_step = 2;
        this.$refs.container.scrollTop = 100;
        this.activeLoading(false)
      })
      .catch(err => {
        this.errors = err.response.data.errors
        this.activeLoading(false)
      });

    },
    submitBuyReq (){
      this.errors = {}
      const api_token = this.getToken()
      const d = new FormData();

      if(this.buy_receipt[0]){
        d.append('receipt_file', this.buy_receipt[0]);
      }else{
        this.$notify({
          group: 'foo',
          type: 'error',
          duration: 5000,
          text: "لطفا تصویر رسید واریزی را وارد نمایید."
        });
        return;
      }

      if(this.buy_receipt[1]){
        d.append('receipt_file2', this.buy_receipt[1]);
      }

      if(this.buy_receipt[2]){
        d.append('receipt_file3', this.buy_receipt[2]);
      }

      this.buy.admin_bank_account_id ? d.append('admin_bank_account_id', this.buy.admin_bank_account_id) : ''
      const paid_amount = this.buy.amount.replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d))
      d.append('paid_amount', paid_amount.replace(/,/g, ""))
      this.buy.bank_account_id ? d.append('bank_account_id', this.buy.bank_account_id) : ''
      this.buy.wallet_id ? d.append('wallet_id', this.buy.wallet_id) : ''

      this.activeLoading(true)
      this.$axios.post(`submitBuyReq` , d,
      {
        headers: {
          'api_token':api_token
        }
      })
      .then( () => {
        this.activeLoading(false)
        this.errors = {}
        this.buy = {
          admin_bank_account_id:null,
          wallet_id:null,
          bank_account_id:null,
          payment_method:null
        }
        this.socket.emit('admin_notification');
        
        // this.$notify({
        //   group: 'foo',
        //   type: 'success',
        //   duration: 5000,
        //   text: 'ثبت درخواست خرید با موفقیت انجام شد.'
        // });

        this.buy_step = 4
        this.$refs.container.scrollTop = 100;
        this.buy_receipt = null
        this.getHistories();
      })
      .catch(err => {
        const error = err.response.data;
        if(error.message){
          this.$notify({
            group: 'foo',
            type: 'error',
            duration: 5000,
            text: error.message
          });
        }else{
          this.errors = error.errors
        }
        this.activeLoading(false)
      });

    },
    submitVandarBuyReq (){
      this.errors = {}
      this.activeLoading(true)
      const api_token = this.getToken()

      let paid_amount = this.buy.amount.replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d));
      paid_amount = paid_amount.replace(/,/g, "");

      this.$axios.post(`vandarPay` , {
        amount:paid_amount,
        wallet_id:this.buy.wallet_id,
      },
      {
        headers: {
          'api_token':api_token
        }
      })
      .then( res => {
        location.href = res.data.data
      })
      .catch(err => {
        const error = err.response.data;
        if(error.message){
          this.$notify({
            group: 'foo',
            type: 'error',
            duration: 5000,
            text: error.message
          });
        }else{
          this.errors = error.errors
        }
        this.activeLoading(false)
      });

    },

    getNetworks (symbol){
      this.$axios.post(`getNetworks` , {symbol:symbol})
      .then(res => {
        this.networks = res.data.data
      })
      .catch( () => {
      });
    },
    getNetworkWalletAddress (network , symbol){
      this.activeLoading(true)
      this.$axios.post(`getNetworkWalletAddress` , {symbol:symbol,network:network})
      .then(res => {
        this.activeLoading(false)
        this.admin_wallet = res.data.data
      })
      .catch( () => {
        this.activeLoading(false)
      });

    },
    checkSellAmount (){
      if(!this.sell.amount){
        this.$notify({ group: 'foo', type: 'error', duration: 5000, text: 'لطفا مقدار ارسالی را وارد نمایید'});
        return
      }
      if(this.sell.amount < 10){
        this.$notify({ group: 'foo', type: 'error', duration: 5000, text: 'مقدار ارسالی شما باید بیشتر از 10 تتر باشد.'});
        return
      }
      this.$refs.container.scrollTop = 100 ;
      this.sell_step = 2
    },
    submitSellReq (){
      this.activeLoading(true)
      const api_token = this.getToken()
      
      this.$axios.post(`submitSellReq`,
      {
        paid_amount : this.sell.amount,
        admin_wallet : this.admin_wallet.address,
        bank_account_id : this.sell.bank_account_id,
        received_amount : this.sell.receive,
        txid : this.sell.txid
      },
      {
        headers: {
          'api_token':api_token
        }
      })
      .then( () => {
        this.socket.emit('admin_notification');
        // this.$notify({
        //   group: 'foo',
        //   type: 'success',
        //   duration: 5000,
        //   text: 'ثبت درخواست فروش با موفقیت انجام شد.'
        // });
        this.activeLoading(false)
        this.sell_step = 3;
        this.$refs.container.scrollTop = 100;
        this.getHistories();
      })
      .catch(err => {
        const error = err.response.data;
        if(error.message){
          this.$notify({
            group: 'foo',
            type: 'error',
            duration: 5000,
            text: error.message
          });
        }else{
          this.errors = error.errors
        }
        this.activeLoading(false)
      });

    },
    reset(){
      this.sell = {
        bank_account_id:null,
        network:null,
      };
      this.admin_wallet = {}
      this.sell_step = 1;
      this.$refs.container.scrollTop = 100;
    },
    CopyText(text){
      navigator.clipboard.writeText(text);
    },
    getHistories(){
      const api_token = this.getToken()
      this.histories = {}
      
      this.$axios.post(`exchangesHistory`,{type:this.active_tab},
      {
        headers: {
          'api_token':api_token
        }
      })
      .then(res => {
        this.histories = res.data.data
      })
      .catch(err => {
      });

    },
    selectAdminBankAccount(){
      const bank_id = this.buy.admin_bank_account_id;
      const bank = this.admin_bank_accounts.find(o => o.id === bank_id);

      this.admin_bank_account = bank;
    },
  },
  mounted() {
    this.activeLoading(false)
    this.checkAuth()
    this.socket = io(this.socketUrl);
    this.checkConfirmed()
    
    this.getNetworks('USDT');
    this.getHistories()
  }
}
</script>
